/* jscs:disable disallowFunctionDeclarations*/
(function(){
  'use strict';

  angular
    .module('AcaApp')
    .controller('SendEmailController', SendEmailController);

  SendEmailController.$inject = [
    '$scope',
    '$mdDialog',
    'dataEmail',
    'SendService',
    'SEND_MESSAGES',
    '$window'
  ];

  function SendEmailController($scope, $mdDialog, dataEmail, SendService, SEND_MESSAGES, window){
    var _this = this;

    /** properties */
    _this.listEmails = [];
    _this.dataToEmail = {};
    _this.parsingData = '';
    _this.selected = [];
    _this.listEmailToSend = [];
    _this.message = '';
    _this.messageClass = '';
    _this.listEmail = false;
    _this.userName = window.sessionStorage.userName;

    /** methods */
    _this.sendEmail = _sendEmail;
    _this.toggle = _toggle;
    _this.toggleAll = _toggleAll;
    _this.exists = _exists;
    _this.isIndeterminate = _isIndeterminate;
    _this.isChecked = _isChecked;
    _this.closeModal = _closeModal;

    _activate();

    /** @private */
    function _activate(){
      dataEmail.listEmails.forEach(function(element){
        _this.listEmails.push(element.value);
      });
    }

    /** @public */
    function _sendEmail(){
      if(_this.selected.length > 0){
        _this.dataToEmail.ListOfEmails = _this.selected.toString();
        var strToken = window.btoa(Math.random() * (100 - 1) + _this.userName);
        var reg = /=/gi;
        _this.dataToEmail.Hash = strToken.replace(reg, '');
        _this.dataToEmail.Description = 'output:' + dataEmail.OutputType + ';codetyperun:' + dataEmail.CodeTypeRun + ';fchar:' + dataEmail.Fchar + ';jobid:' + dataEmail.JobId + ';filename:' + dataEmail.FileName + ';userName:' + _this.userName +
                                        ';ids:' + dataEmail.ids + ';parentIds:' + dataEmail.parentIds;
        _this.dataToEmail.TypeTitle = dataEmail.TypeTitle;
        _this.dataToEmail.TypeFile = dataEmail.TypeFile;
        SendService.sendEmailToApprove(_this.dataToEmail).then(_checkConfirmedSendEmail, _error);
      }
      else{
        _this.message = SEND_MESSAGES.NOEMAILSELECTED;
        _this.messageClass = SEND_MESSAGES.ERRORMESSAGEEMAILCLASS;
      }
    }

    /** @public */
    function _toggleAll(){
      if(_this.selected.length === _this.listEmails.length){
        _this.selected = [];
      }
      else if(_this.selected.length === 0 || _this.selected.length > 0){
        _this.selected = _this.listEmails.slice(0);
      }
    }

    /** @public */
    function _toggle(item, list){
      var idx = list.indexOf(item);
      if(idx > -1) {
        list.splice(idx, 1);
      }
      else{
        list.push(item);
      }
    }

    /** @public */
    function _exists(item, list){
      return list.indexOf(item) > -1;
    }

    /** @public */
    function _isIndeterminate(){
      return (_this.selected.length !== 0 &&
      _this.selected.length !== _this.listEmails.length);
    }

    /** @public */
    function _isChecked(){
      return _this.selected.length === _this.listEmails.length;
    }

    /** @public */
    function _closeModal(){
      $mdDialog.hide();
    }

    /** private */
    function _checkConfirmedSendEmail(response){
      if(response.result.value){
        _this.message = SEND_MESSAGES.MESSAGEOK;
        _this.messageClass = SEND_MESSAGES.OKMESSAGECLASS;
        _this.listEmail = true;
        window.sessionStorage.hash = _this.dataToEmail.Hash;
      }
    }

    /** @private */
    function _error(error){
      $mdDialog.hide();
      /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
      _this.message = error.data.error.frontend_message;
      _this.messageClass = SEND_MESSAGES.ERRORMESSAGEEMAILCLASS;
      _this.listEmail = true;
    }
  }
})();
